import { AddonsMetaID } from '@/components/addons/consts';
import { WorkspaceT } from '@/pages/workgroup/type';

export const isWorkspaceInsightsEnable = (workspace?: WorkspaceT) =>
  Boolean(workspace?.addons?.find((i) => i.addons_id === AddonsMetaID.INSIGHTS)?.enable);
